<template>
  <div class="relative">
    <div
      v-if="imageUrl"
      class="relative border border-gray-300 rounded-lg overflow-hidden bg-gray-50"
    >
      <img :src="imageUrl" alt="Screenshot preview" class="max-h-[300px] w-auto mx-auto block" />
      <button
        @click="$emit('remove')"
        class="absolute top-2 right-2 bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded text-sm transition-colors"
      >
        Supprimer
      </button>
    </div>
    <div
      v-else
      class="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center text-gray-500"
    >
      <Camera class="w-12 h-12 mx-auto mb-2 opacity-50" />
      <p class="text-sm">Aucun screenshot</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Camera } from 'lucide-vue-next'

defineProps<{
  imageUrl?: string
  showChangeButton?: boolean
}>()

defineEmits<{
  change: []
  remove: []
}>()
</script>
